import styled, { css } from "styled-components";
import Button from "./Button";

const LabelEl = styled.div<{ removeFlag: boolean }>`
  display: inline-block;
  position: relative;
  min-width: 60px;
  padding: 0 10px;
  border-radius: 6px;
  background-color: #f9fafc;
  border: 1px solid var(--border-normal);
  color: #444;
  font-size: 0.98rem;
  line-height: 38px;
  text-align: center;

  ${props => {
    if (props.removeFlag) {
      return css`
        padding-right: 15px;

        button {
          margin-left: 8px;
          padding: 15px 1px;
          width: 12px;
          height: 12px;
          &::before {
            width: 12px;
            height: 12px;
          }

          &:hover {
            background-color: transparent;
          }
        }
      `;
    }
  }}
`;

interface ILabelProps {
  text: string;
  useRemove?: boolean;
  onClick?: () => void;
}

/**
 * 태그 라벨 컴포넌트
 * @param text 태그명
 * @param useRemove 삭제 버튼 사용여부
 * @param onClick 삭제버튼 클릭 이벤트
 */
function TagLabel(props: ILabelProps) {
  return (
    <LabelEl removeFlag={props.useRemove !== undefined ? props.useRemove : false}>
      {props.text}
      {props.useRemove && (
        <Button btnType="ghost" iconName="Closed" iconPosition="center" color={"dark"} onClick={props.onClick} />
      )}
    </LabelEl>
  );
}

export default TagLabel;
